import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import SVGTrash from '../../svg/Trash.js';
import SVGRecipeCard from '../../svg/RecipeCard.js';
import { menuAPI } from '../../InterfaceAPI/menuAPI';
import { flattenArray } from '../../helpers/util';
import SimpleInput from '../form/SimpleInput';

class ServiceSelectedDishes extends React.Component {
  state = {
    menuSelections: [],
    special_instructions: ''
  };
  isRequestOut = false;

  render() {
    const { menuSelections, special_instructions } = this.state;
    const numSelectedDishes = menuSelections.reduce(
      (total, selection) => selection.quantity + total,
      0
    );

    return (
      <div className="menu-selection-container">
        <div className="selected-dishes">
          <div className="h4">Selected Dishes: {numSelectedDishes}</div>
          {this.renderSelections(menuSelections)}
        </div>
        <div className="p--pad-top">
          <p className="p p--bold">Special Instructions</p>
          <textarea
            name="special_instructions"
            value={special_instructions || ''}
            onChange={e => this.handleSpecialInstructionsChange(e)}
            className="simple-input simple-input--text-area"
          ></textarea>
          <br />
          <br />
        </div>
      </div>
    );
  }

  renderSelections(menuSelections) {
    if (menuSelections.length === 0) return '';
    return (
      <div className="selected-dishes">
        {this.renderSelectionHeader()}
        {menuSelections.map((selection, i) =>
          this.props.isEdit
            ? this.renderSelectionEdit(selection, i)
            : this.renderSelectionView(selection, i)
        )}
      </div>
    );
  }

  renderSelectionHeader = () => {
    return (
      <div className="row row--space-between row--pad row--border-bottom">
        <div className="p row__item row__item--twentieth p--bold">Qty</div>
        <div className="p row__item row__item--fourth p--bold">Dish</div>
        <div className="p row__item row__item--fourth p--bold">Course</div>
        <div className="p row__item row__item--tenth p--bold">Portions</div>
        <div className="p row__item row__item--fourth p--bold">
          Please share with us any dish specific requests:
        </div>
        <div className="p row__item row__item--tenth p--bold">
          {this.props.isEdit ? '' : 'Recipe Card'}
        </div>
      </div>
    );
  };

  renderSelectionView(selection, i) {
    const { quantity, notes, dish, course_name, portion } = selection;
    const dishName = dish && 'name' in dish ? dish.name : '';
    const dishChildName = dish && 'child_name' in dish ? dish.child_name : '';
    const recipeCardUrl =
      dish &&
      'recipe_card' in dish &&
      dish.recipe_card &&
      'url' in dish.recipe_card
        ? dish.recipe_card.url
        : '';
    const dishRecipeCard = recipeCardUrl ? (
      <Link className="a--blue" target="_blank" to={`${recipeCardUrl}`}>
        <div className="image-upload__placeholder-icon">
          <SVGRecipeCard />
        </div>
      </Link>
    ) : (
      ''
    );

    return (
      <div className="row row--space-between row--pad row--centered" key={i}>
        <div className="row__item row__item--twentieth">
          <p className="p">{quantity}</p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p ">
            {dishName}{' '}
            <span className="p--em p--new-line">{dishChildName}</span>
          </p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p p--truncate">{course_name || ''}</p>
        </div>
        <div className="row__item row__item--tenth">
          <p className="p">{portion}</p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p">{notes}</p>
        </div>
        <div className="row__item row__item--tenth">
          <p className="p">{dishRecipeCard}</p>
        </div>
      </div>
    );
  }

  renderSelectionEdit(selection, i) {
    const { quantity, notes, dish, course_name, portion } = selection;
    const dishName = dish && 'name' in dish ? dish.name : '';
    const dishChildName = dish && 'child_name' in dish ? dish.child_name : '';

    return (
      <div className="row row--space-between row--bordered" key={i}>
        <div className="row__item row__item--twentieth">
          <p className="p">{quantity}</p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p">
            {dishName}{' '}
            <span className="p--em p--new-line">{dishChildName}</span>
          </p>
        </div>
        <div className="row__item row__item--fourth">
          <p className="p p--truncate ">{course_name || ''}</p>
        </div>
        <div className="p row__item row__item--tenth">
          <SimpleInput
            type="number"
            name="portion"
            value={portion}
            onChange={e => this.handleChange(e, i)}
          />
        </div>
        <div className="p row__item row__item--fourth">
          <SimpleInput
            name="notes"
            value={notes || ''}
            onChange={e => this.handleChange(e, i)}
          />
        </div>
        <div className="p row__item row__item--twentieth">
          <div onClick={() => this.linkToDish(dish)} className="a--blue">
            Edit
          </div>
        </div>
        <div className="p row__item row__item--twentieth">
          <span
            className="btn-icon btn-icon--trash"
            onClick={() => this.handleDeleteDish(i)}
          >
            <SVGTrash />
          </span>
        </div>
      </div>
    );
  }

  linkToDish = dish => {
    const { service } = this.props;
    const pathname = dish.id ? `/admin/dish/${dish.id}` : '/admin/dish/';

    this.props.setServiceUnsaved(false, () =>
      this.props.history.push({
        pathname,
        state: {
          dish, // loaded by Dish
          redirect_url: `/admin/service/${service.id}`,
          redirect_payload: { service }
        }
      })
    );
  };

  handleChange = (e, index) => {
    const { name, value } = e.target;
    const menu_selections = this.state.menuSelections;

    menu_selections[index][name] = value;
    this.props.updateService({ menu_selections });
  };

  handleSpecialInstructionsChange = e => {
    const { value } = e.target;

    this.setState({ special_instructions: value});
    this.props.updateService({ special_instructions: value });
  };

  handleDeleteDish = index => {
    const { menuSelections } = { ...this.state };
    let menu_selections = [];

    // if found, create new courses array without the deleted
    if (index > -1)
      menu_selections = [
        ...menuSelections.slice(0, index),
        ...menuSelections.slice(index + 1, menuSelections.length)
      ];

    this.props.updateMenuSelections(menu_selections);
  };

  populateSelections() {
    const { menuSelections, menu } = this.props;

    if (!menu.courses) return menuSelections;

    const selections = [...menuSelections];
    const dishes = flattenArray(menu.courses.map(course => course.dishes));

    return selections.map(selection =>
      this.populateSelectionFromMenu(selection, dishes)
    );
  }

  populateSelectionFromMenu(menuSelection, dishes) {
    if (menuSelection.dish) return menuSelection;

    menuSelection.dish =
      dishes.find(dish => dish.id === menuSelection.dish_id) || null;
    return menuSelection;
  }

  populateSelectionsFromAPI(lookups) {
    // get the dish ids to look up
    const dishIDs = lookups.map(lookup => lookup.menuSelection.dish_id);
    if (!dishIDs) return;

    // search for the ids
    this.isRequestOut = true;

    this.getDishes(dishIDs)
      .then(dishes => {
        const menuSelections = [...this.state.menuSelections];
        // update the menuSelections with the dish
        lookups.forEach(({ index, menuSelection }) => {
          menuSelection.dish = dishes.find(
            dish => dish.id === menuSelection.dish_id
          );
          menuSelections[index] = menuSelection;
        });

        this.isRequestOut = false;
        this.setState({ menuSelections });
      })
      .catch(err => console.log(err));
  }

  // get the dishes from the API
  getDishes = dishIds => {
    return Promise.all(dishIds.map(this.mapGetRequest));
  };

  mapGetRequest = id => menuAPI.getDish(id);

  verifySelections() {
    if (this.isRequestOut) return;

    // loop props.menuSelections for missing dishes,
    // trigger populateSelectionFromAPI on missing dishes
    const lookupMaps = this.state.menuSelections
      .map((menuSelection, index) => {
        return { index, menuSelection };
      })
      .filter(map => !('dish' in map.menuSelection) || !map.menuSelection.dish);

    if (lookupMaps.length > 0) this.populateSelectionsFromAPI(lookupMaps);
  }

  componentDidMount() {
    const menuSelections = this.populateSelections();
    this.setState(
      {
        menuSelections,
        special_instructions: this.props.service.special_instructions
      },
      this.verifySelections
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.menuSelections !== this.props.menuSelections ||
      this.state.special_instructions !==
        this.props.service.special_instructions
    ) {
      this.setState(
        {
          menuSelections: this.props.menuSelections,
          special_instructions: this.props.service.special_instructions
        },
        this.verifySelections
      );
    }
  }
}

export default withRouter(ServiceSelectedDishes);



// WEBPACK FOOTER //
// ./src/components/service/ServiceSelectedDishes.js